<div class="content gov-content" role="main">
  <app-tenders></app-tenders>
</div>
